const content = {
  title: "Past Continuous",
  explanation: `
We use the Past Continuous for actions that were in progress at a specific past moment.
Example: At 8 p.m., I was doing my homework.

It is very useful for background actions in stories.
Example: The children were playing while their parents were cooking.

We often combine it with Past Simple for interruption.
Example: I was walking home when it started to rain.

At A2 level, focus on timeline meaning: long action in progress + short interrupting action.
Example: She was studying when her friend called.
  `,
  rules: [
    "Form: was / were + verb + ing",
    "I / He / She / It → was + verb + ing",
    "You / We / They → were + verb + ing",
    "Often used with time expressions like 'when' and 'while'"
  ],
  examples: [
    "I was studying at 8 PM yesterday.",
    "She was watching TV when I called.",
    "They were playing football while it was raining.",
    "He was working when the phone rang.",
    "We were having dinner at that time."
  ]
};

export default content;


